import React from "react";
import * as CheckboxPrimitive from "@/components/ui/checkbox";

const { Checkbox: RCheckbox } = CheckboxPrimitive as any;

export function Checkbox({
  checked,
  onChange,
  testid,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  testid?: string;
}) {
  return <RCheckbox checked={checked} onCheckedChange={(v: boolean) => onChange(!!v)} data-testid={testid} />;
}
